"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _reactRouterDom = require("react-router-dom");

var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));

var _react = _interopRequireWildcard(require("react"));

var _logo_placeholder = _interopRequireDefault(require("./images/logo_placeholder.png"));

var _reactSlick = _interopRequireDefault(require("react-slick"));

var _axios = _interopRequireDefault(require("axios"));

var _idbReactQr = _interopRequireDefault(require("@identitybuilding/idb-react-qr"));

var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var BusinessCard = function BusinessCard(_ref) {
  var entity = _ref.entity,
      index = _ref.index,
      cardOn = _ref.cardOn,
      lang = _ref.lang;

  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };

  var _desktop = "desktop",
      device = _desktop.device;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      cardIndex = _useState2[0],
      setCardIndex = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = (0, _react.useState)(cardOn),
      _useState6 = _slicedToArray(_useState5, 2),
      on = _useState6[0],
      setOn = _useState6[1];

  var cardBack = index === cardIndex;
  var node = (0, _react.useRef)();

  var _useState7 = (0, _react.useState)(null),
      _useState8 = _slicedToArray(_useState7, 2),
      isOpen = _useState8[0],
      setIsOpen = _useState8[1];

  var _useState9 = (0, _react.useState)(new Date().toLocaleString("en-us", {
    weekday: "long"
  }).toLowerCase()),
      _useState10 = _slicedToArray(_useState9, 1),
      currentDay = _useState10[0];

  var _useState11 = (0, _react.useState)(false),
      _useState12 = _slicedToArray(_useState11, 2),
      activeIndex = _useState12[0],
      setActiveIndex = _useState12[1]; // This handles the connection between the card and the marker on the map


  var cardMarkerHandler = function cardMarkerHandler(action) {
    // Get the card's corresponding marker based on the corresponding id
    var card = document.getElementsByClassName("card");
    if (card) ; // card[index].classList.add('active')

    for (var i = 0; i < card.length; i++) {
      card[i].classList.remove("active");

      if (i === index) {
        if (action === "in") {
          card[i].classList.add("active");
          setOn(true);
        } else {
          card[i].classList.remove("active");
          setOn(false);
        }
      }
    }
  };

  (0, _react.useEffect)(function () {
    getData();
  }, []);

  var handleClick = function handleClick(e) {
    // Clicking on the card
    if (node.current === e.currentTarget && activeIndex === false) {
      cardMarkerHandler("in");
      setActiveIndex(index);
      return;
    } else {
      cardMarkerHandler("out");
      setActiveIndex(false);
    }
  };

  var name_1 = data.name ? data.name && data.name.toLocaleLowerCase() === data.enterprise_name.toLocaleLowerCase() && data.juridical_form ? data.name + " " + (!data.hide_abbreviation_in_front_end ? data.juridical_form : "") : data.name : data.juridical_form ? data.enterprise_name + (!data.hide_abbreviation_in_front_end ? " " + data.juridical_form : "") : data.enterprise_name;
  var getData = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var id, result, search_id, logo_model, contact_model;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            id = entity; // let result = await ReadEntity({ id: id, lang: lang, live: live });

            result = {
              entity: {}
            };
            search_id = entity; // Get names of the enterprise / establishment

            logo_model = require("./models/LogoModel")["default"];
            contact_model = require("./models/ContactModel")["default"];
            _context.next = 7;
            return _axios["default"].get("https://search-osn-management-hkfarflgp5aj2vbhfzvmyycuuy.eu-central-1.es.amazonaws.com/_search?q=number:".concat(search_id), {
              // auth: {
              //     username: `${process.env.REACT_APP_ESUSERNAME}`,
              //     password: `${process.env.REACT_APP_ESPSW}`,
              // },
              auth: {
                username: "osn-admin",
                password: "O15s19n14!+"
              }
            }).then(function (res) {
              var enterprise_names = res.data.hits.hits[0]._source.from_enterprise;
              result.entity.enterprise_name = enterprise_names["official_name_".concat(lang)] || enterprise_names.official_name_nl || enterprise_names.official_name_fr || enterprise_names.official_name_de || enterprise_names.official_name_en;

              if (res.data.hits.hits[0]._source.name_nl || res.data.hits.hits[0]._source.name_fr || res.data.hits.hits[0]._source.name_de || res.data.hits.hits[0]._source.name_en && res.data.hits.hits[0]._source.name_nl !== "-") {
                result.entity.establishment_name = res.data.hits.hits[0]._source["name_".concat(lang)] || res.data.hits.hits[0]._source.name_nl || res.data.hits.hits[0]._source.name_fr || res.data.hits.hits[0]._source.name_de || res.data.hits.hits[0]._source.name_en;
              }

              if (res.data.hits.hits[0]._source.from_enterprise["official_name_".concat(lang)] && res.data.hits.hits[0]._source.from_enterprise["official_name_".concat(lang)].toLowerCase() || result.entity.enterprise_name || result.entity.enterprise_name.toLowerCase() === result.entity.establishment_name || result.entity.establishment_name.toLowerCase()) {// result.entity.name = result.entity.enterprise_name;
              } else {// result.entity.name = res.data.hits.hits[0]._source.name_nl
                  //   ? res.data.hits.hits[0]._source.name_nl
                  //   : res.data.hits.hits[0]._source.from_enterprise.official_name_nl;
                }

              result.entity.name = result.entity.establishment_name ? result.entity.establishment_name === result.entity.enterprise_name ? result.entity.enterprise_name : result.entity.establishment_name : result.entity.enterprise_name;
              result.entity.juridical_form = res.data.hits.hits[0]._source.from_enterprise["juridical_form_".concat(lang)] || res.data.hits.hits[0]._source.from_enterprise.juridical_form_nl || res.data.hits.hits[0]._source.from_enterprise.juridical_form_fr || res.data.hits.hits[0]._source.from_enterprise.juridical_form_de || res.data.hits.hits[0]._source.from_enterprise.juridical_form_en;
              result.entity.hide_abbreviation_in_front_end = false;
              result.entity.id = entity.search_id;
              result.entity.link_to_bp = "".concat(res.data.hits.hits[0]._source.search_id, "/").concat(result.entity.name ? result.entity.name.toLocaleLowerCase().split(/[\s/]/).join("-") : result.entity.enterprise_name.toLocaleLowerCase().split(/[\s/]/).join("-")); // result.entity.link_to_bp = entity.search_id

              result.entity.vat_number = result.entity.link_to_bp.slice(0, 12).replace(/\./g, "");
              result.entity.establishment_number = search_id;
              var main_address = res.data.hits.hits[0]._source.address;
              result.entity.address = {};
              result.entity.address.lat = main_address.latitude ? String(main_address.latitude) : "";
              result.entity.address["long"] = main_address.longitude ? String(main_address.longitude) : "";
              result.entity.address.postal = main_address.postal_code ? main_address.postal_code : "";
              result.entity.address.municipality = main_address["municipality_".concat(lang)] || main_address.municipality_nl || main_address.municipality_fr || main_address.municipality_de || main_address.municipality_en;
              result.entity.address.sub_municipality = main_address["sub_municipality_".concat(lang)] || main_address.sub_municipality_nl || main_address.sub_municipality_fr || main_address.sub_municipality_de || main_address.sub_municipality_en;
              result.entity.address.street = main_address["streetname_".concat(lang)] || main_address.streetname_nl || main_address.streetname_fr || main_address.streetname_de || main_address.streetname_en;
              result.entity.address.number = main_address.house_number;
              result.entity.address.box = main_address.box_number;
              result.entity.address.extra_info = main_address.extra_address_info;

              if (result.entity.address.municipality === result.entity.address.sub_municipality) {
                result.entity.address.sub_municipality = "";
              }

              result.entity.address.line_1 = "".concat(result.entity.address.street, " ").concat(result.entity.address.number).concat(result.entity.address.box && result.entity.address.box !== "None" ? "/".concat(result.entity.address.box) : "");
              result.entity.address.line_2 = "".concat(result.entity.address.postal, " ").concat(result.entity.address.sub_municipality ? result.entity.address.sub_municipality : result.entity.address.municipality, " ").concat(result.entity.address.municipality ? result.entity.address.sub_municipality ? "(".concat(result.entity.address.municipality, ")") : "" : "");
              result.entity.logos = logo_model(res.data.hits.hits[0]._source.logolinks, lang);
              result.entity.telephone = contact_model(res.data.hits.hits[0]._source.contactmethodlinks, lang).telephone;
              result.entity.mobile_phone = contact_model(res.data.hits.hits[0]._source.contactmethodlinks, lang).mobile_phone;
              result.entity.fax = contact_model(res.data.hits.hits[0]._source.contactmethodlinks, lang).fax;
              result.entity.website = contact_model(res.data.hits.hits[0]._source.contactmethodlinks, lang).website;
            })["catch"](function (error) {
              console.log(error);
            });

          case 7:
            if (!result.entity.address) {
              _context.next = 11;
              break;
            }

            if (!(!result.entity.address["long"] && !result.entity.address.lat || result.entity.address["long"] === "0.000000000000000" || result.entity.address.lat === "0.000000000000000")) {
              _context.next = 11;
              break;
            }

            _context.next = 11;
            return _axios["default"].get("https://nominatim.openstreetmap.org/search?q=".concat(result.entity.address.line_1, "%20").concat(result.entity.address.municipality, "&format=json")).then(function (res) {
              if (result.entity && res.data.length > 0) {
                result.entity.address.lat = res.data[0].lat;
                result.entity.address["long"] = res.data[0].lon;
              }
            });

          case 11:
            // send the address data back to results to store them all in one array
            // console.log(result.entity)
            setData(result.entity); // if (open.data.open_timetable && open.data.is_open === true) {
            //   setupWeek(open.data.open_timetable);
            // }

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), []);
  var settings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 3000,
    dots: false,
    infinite: true,
    initialSlide: 0,
    lazyload: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    speed: 500,
    variableWidth: false,
    pauseOnhover: true,
    swipe: false
  };

  var handleHover = function handleHover(action) {
    var marker = document.querySelectorAll(".marker_".concat(data.id))[0];

    if (action === "in") {
      marker && marker.childNodes[0].classList.add("active");
      marker && marker.childNodes[0].classList.add("click");
      if (marker) marker.style.zIndex = 999;
      marker && marker.classList.add("active");
      marker && marker.classList.add("click");
    }
  };

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "card \n        ".concat(cardBack ? "activated" : "", " \n        ").concat(!data.logos ? "loading-logo" : "", " \n        ").concat(!data.name && !data.address ? "loading-data" : "", " \n        ").concat(activeIndex, " \n        ").concat(isOpen === true ? "open" : isOpen === false ? "" : isOpen === "almost" && "almost", "\n      ") // ${isOpen === true ? 'open' : isOpen === false ? 'closed' : isOpen === 'almost' && 'almost'}
    ,
    id: data.id && data.id.replace(/\./g, "_"),
    onMouseLeave: function onMouseLeave() {
      cardBack && setCardIndex(false);
      handleHover("out", data);
    },
    onClick: function onClick(e) {
      return handleClick(e);
    },
    onMouseOver: function onMouseOver(e) {
      return handleHover("in", data);
    },
    ref: node
  }, device === "desktop" && /*#__PURE__*/_react["default"].createElement("div", {
    className: "businessCardIcons"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    className: "qrIcon ".concat(cardBack ? "active" : ""),
    name: !cardBack ? "Qr" : "Osn",
    onClick: function onClick() {
      cardBack === true ? setCardIndex(false) : setCardIndex(index);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardLogoWrapper ".concat(data.logos && data.logos.length > 1 ? "multiple" : "")
  }, data.logos && data.logos.length > 0 && data.logos.length > 1 ? /*#__PURE__*/_react["default"].createElement(_reactSlick["default"], settings, data.logos.map(function (logo, index) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "cardLogo inner",
      key: index
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: cardBack ? data.qr && data.qr : logo.logo,
      alt: "Logo ".concat(data.name ? data.name : data.enterprise_name),
      title: "Logo ".concat(data.name ? data.name : data.enterprise_name)
    }));
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardLogo"
  }, cardBack && data.qr ? /*#__PURE__*/_react["default"].createElement("img", {
    src: data.qr,
    alt: "Logo ".concat(data.name ? data.name : data.enterprise_name),
    title: "Logo ".concat(data.name ? data.name : data.enterprise_name)
  }) : index > 11 ? /*#__PURE__*/_react["default"].createElement("img", {
    "data-expand": "-50",
    className: "lazyload",
    src: cardBack ? data.qr && data.qr : data.logos && data.logos[0] ? data.logos[0].logo : _logo_placeholder["default"],
    alt: "Logo ".concat(data.name ? data.name : data.enterprise_name),
    title: "Logo ".concat(data.name ? data.name : data.enterprise_name)
  }) : cardBack ? /*#__PURE__*/_react["default"].createElement(_idbReactQr["default"], {
    cell: data.mobile_phone[0],
    color: "#000",
    name: data.establishment_name,
    tel: data.telephone[0],
    url: data.website
  }) : /*#__PURE__*/_react["default"].createElement("img", {
    src: cardBack ? data.qr && data.qr : data.logos && data.logos[0] ? data.logos[0].logo : _logo_placeholder["default"],
    alt: "Logo ".concat(data.name ? data.name : data.enterprise_name),
    title: "Logo ".concat(data.name ? data.name : data.enterprise_name)
  }))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardContent"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "res_name"
  }, /*#__PURE__*/_react["default"].createElement("h2", {
    title: name_1
  }, name_1), data.enterprise_name && data.name && data.name.toLocaleLowerCase() !== data.enterprise_name.toLocaleLowerCase() && /*#__PURE__*/_react["default"].createElement("h3", {
    title: data.juridical_form && !data.hide_abbreviation_in_front_end ? data.enterprise_name + " " + data.juridical_form : data.enterprise_name
  }, data.juridical_form && !data.hide_abbreviation_in_front_end ? data.enterprise_name + " " + data.juridical_form : data.enterprise_name)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardRow"
  }, /*#__PURE__*/_react["default"].createElement("img", {
    style: {
      padding: "0"
    },
    className: "icon",
    src: require("./images/nismarker.svg"),
    alt: "marker icon"
  }), /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "card_address",
    title: "".concat(data && data.address && data.address.line_1)
  }, data && data.address && data.address.line_1), data && data.address && data.address.extra_info && /*#__PURE__*/_react["default"].createElement("span", {
    className: "card_address",
    title: "".concat(data.address.extra_info)
  }, "(", data.address.extra_info, ")"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "card_address",
    title: "".concat(data && data.address && data.address.line_2)
  }, data && data.address && data.address.line_2))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardRow"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "res_telephone"
  }, data.telephone && data.telephone.length > 0 && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Phone"
  }), data.telephone[0]), !data.fax && data.mobile_phone && data.mobile_phone.length > 0 && !data.telephone && data.mobile_phone && data.mobile_phone.length > 0 ? // if no telephone is given and there are multiple mobile_phones, show 2 mobile_phones
  data.mobile_phone.map(function (res, index) {
    return /*#__PURE__*/_react["default"].createElement("span", {
      key: index
    }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
      name: "Cellphone"
    }), data.mobile_phone[index]);
  }) : // Else only show one
  data.mobile_phone && data.mobile_phone.length > 0 && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Cellphone"
  }), data.mobile_phone[0]), data.fax && (data.mobile_phone && data.mobile_phone.length === 0 || !data.telephone) && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Fax"
  }), data.fax)))), (data || data.website) && /*#__PURE__*/_react["default"].createElement("div", {
    className: "cardLinks"
  }, device === "mobile" && !data.website && /*#__PURE__*/_react["default"].createElement("a", {
    title: translate("add_as_contact"),
    className: "cl_qr",
    href: "".concat(process.env.REACT_APP_BASE_MEDIA_URL, "/public/business/").concat(data.id, "/vcard"),
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "AddCircle"
  }), (!data.website || !data.telephone) && /*#__PURE__*/_react["default"].createElement("span", null, translate("add_as_contact"))), data.website && /*#__PURE__*/_react["default"].createElement("a", {
    className: "cl_website",
    href: "".concat(data.website),
    rel: "noopener noreferrer",
    target: "_blank"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Website"
  }), /*#__PURE__*/_react["default"].createElement("span", null, translate("visit_site"))), data && data.telephone && data.telephone.length > 0 && /*#__PURE__*/_react["default"].createElement("a", {
    className: "cl_phone",
    href: "tel:".concat(data.telephone[0])
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Phone"
  })), data.link_to_bp && /*#__PURE__*/_react["default"].createElement("a", {
    className: "cl_bp",
    href: "/business/".concat(data.link_to_bp, "/contact")
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "show"
  }, translate("discover_more")), /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "DoubleRight"
  }))));
};

var _default = BusinessCard;
exports["default"] = _default;